import parseExpression from './src/parse'
import precisionCalc from './src/precisionCalc'

function calc(str) {
    return parseExpression(str)
}

for (const key in precisionCalc) {
    calc[key] = precisionCalc[key]
}

export default calc



// WEBPACK FOOTER //
// ./src/lib/calc/index.js